import { Box } from "@mui/material";

import BloodTestResults from './BloodTestResults';
import SmartWatchResults from './SmartWatchResults';
import IoTResults from './IoTResults';

export default function PointOfCare({ pid, hwRegist, page })
{
    return (
        <Box sx={{
            color: '#263238',
            display: 'grid',
            fontSize: 18,
            gridTemplateColumns: '1fr',
            mx: { xl: '2rem', lg: '2rem', md: '2rem', sm: '2rem', xs: '2rem 1rem' },
            '@media (max-width: 1023px)': { fontSize: 14, },
            '@media (max-width: 800px)': { fontSize: 12, }
        }}>
            {page === 0 && <BloodTestResults PID={pid} /> }
            {page === 1 && <SmartWatchResults PID={pid} hwRegistered={hwRegist} />  }
            {page === 2 && <IoTResults PID={pid} /> }

        </Box>
    )
}